import { EmployeeLicenseSummaryState } from './EmployeeLicenseSummaryState';
import { EmployeeLicenseSummaryWarning } from './EmployeeLicenseSummaryWarning';
import { makeArray } from './Model';

export class EmployeeLicenseSummary {
  states?: EmployeeLicenseSummaryState[];

  warnings: EmployeeLicenseSummaryWarning[];

  constructor(obj: any) {
    Object.assign(this, obj);
    this.states = (makeArray(
      obj.states,
      EmployeeLicenseSummaryState,
    ) as EmployeeLicenseSummaryState[]).toSorted(
      EmployeeLicenseSummaryState.sortCompact,
    );
    this.warnings = makeArray(obj.warnings, EmployeeLicenseSummaryWarning);
  }
}

export default EmployeeLicenseSummary;
